import { render, staticRenderFns } from "./CsrfInput.vue?vue&type=template&id=8b880910"
import script from "./CsrfInput.vue?vue&type=script&lang=js"
export * from "./CsrfInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports